<template>
  <v-col cols="12">
    <template v-if="isConfirmed">
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-card outlined>
            <v-card-text>
              <v-img :src="barcode" />
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th class="text-left">
                        TRX #
                        <v-icon
                          @click="
                            $router.push({
                              name: 'SaleDetail',
                              params: { id: info.id },
                            })
                          "
                        >
                          mdi-link
                        </v-icon>
                      </th>
                      <td>
                        {{ info.key }}
                      </td>
                    </tr>
                    <tr>
                      <th>Sale Tax {{ info.taxRate }}%</th>
                      <td>{{ info.taxAmount | currency }}</td>
                    </tr>
                    <tr>
                      <th>Applied Discount {{ info.discountRate }}%</th>
                      <td>{{ info.discountedAmount | currency }}</td>
                    </tr>
                    <tr v-if="customer">
                      <th>
                        Customer
                        <v-icon
                          @click="
                            $router.push({
                              name: 'CustomerDetail',
                              params: { id: customer.id },
                            })
                          "
                        >
                          mdi-link
                        </v-icon>
                      </th>
                      <td>
                        {{ customer.firstName | capitalize }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            class="mt-3"
          >
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th class="text-left">
                        Payment
                      </th>
                      <td>
                        {{ info.totalAmount | currency }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <v-card
            v-if="info.shippingRecipient"
            outlined
            class="mt-3"
          >
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th class="text-left">
                        Shipping Status
                      </th>
                      <td>
                        {{ info.shippingStatus ? "Sent" : "Pending" }}
                      </td>
                    </tr>
                    <tr>
                      <th>Shipping Amount</th>
                      <td>{{ info.shippingAmount | currency }}</td>
                    </tr>
                    <tr>
                      <th>Info</th>
                      <td>{{ info.shippingInfo }}</td>
                    </tr>
                    <tr>
                      <th>Recipient</th>
                      <td>{{ info.shippingRecipient }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <v-card outlined>
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Item
                      </th>
                      <th class="text-left">
                        Code
                      </th>
                      <th class="text-left">
                        Price
                      </th>
                      <th class="text-left">
                        Qty
                      </th>
                      <th class="text-left">
                        Sub Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in products"
                      :key="item.name"
                    >
                      <td>
                        <v-icon @click="editItem(item)">
                          mdi-pencil-box-outline
                        </v-icon>
                        <v-icon @click="removeItem(item)">
                          mdi-close-octagon
                        </v-icon>
                        {{ item.name | uppercase }}
                      </td>
                      <td>{{ item.sku }}</td>
                      <td>
                        {{ item.price | currency }}
                      </td>
                      <td>
                        {{ item.qty }}
                      </td>
                      <td>
                        {{ item.subTotal | currency }}
                      </td>
                    </tr>
                    <tr class="active">
                      <td
                        colspan="4"
                        class="text-right"
                      >
                        <v-icon
                          class="pr-8"
                          @click="confirmSale"
                        >
                          mdi-refresh
                        </v-icon>
                        Total ({{ items }})
                      </td>
                      <td>{{ price | currency }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            class="mt-3"
          >
            <v-card-text>
              <v-simple-table dense>
                <template>
                  <tbody class="text-right">
                    <tr class="active">
                      <th class="text-left">
                        Refundable Amount ({{ items }} items) :
                      </th>
                      <td>{{ price | currency }}</td>
                    </tr>

                    <tr
                      v-if="info.shippingAmount > 0"
                      class="active"
                    >
                      <th class="text-left">
                        With Shipping : {{ info.shippingAmount | currency }}
                      </th>
                      <td>{{ withShipping | currency }}</td>
                    </tr>

                    <tr
                      v-if="info.taxRate > 0"
                      class="active"
                    >
                      <th class="text-left">
                        Tax Fall : {{ info.taxRate }}% |
                        {{ taxAmount | currency }}
                      </th>
                      <td>{{ totalWithTax | currency }}</td>
                    </tr>

                    <tr
                      v-if="info.discountRate > 0"
                      class="active"
                    >
                      <th class="text-left">
                        After Reverse Discount : {{ info.discountRate }}% |
                        {{ discountAmount | currency }}
                      </th>
                      <td>{{ totalAfterDiscount | currency }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            class="mt-3"
          >
            <v-card-text>
              <v-col>
                <v-select
                  v-model="info.gateway"
                  :items="gateways"
                  outlined
                  label="Select gateway"
                  dense
                />
              </v-col>
              <v-col>
                <v-textarea
                  v-model="info.note"
                  label="Refund Payment Note"
                  outlined
                  rows="2"
                  dense
                />
                <v-btn
                  color="info"
                  @click="submitRefund"
                >
                  Proceed
                </v-btn>
                <v-btn @click="$router.back()">
                  Back
                </v-btn>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-icon>mdi-cart-off</v-icon> Enter Transaction ID
      <v-row class="mt-5 ">
        <v-col cols="12">
          <v-text-field
            v-model="key"
            hide-details="auto"
            label="TRX"
            outlined
            dense
            :error-messages="notFound"
          />
        </v-col>
        <v-col
          cols="4"
          class="pl-3"
        >
          <v-btn
            class="error"
            :disabled="key.length < 5"
            @click="confirmSale"
          >
            Confirm & retrieve
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <v-dialog
      v-model="showEditDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-text>
          <v-col>
            <v-text-field
              v-model="editingItem.qty"
              hide-details="auto"
              label="Returning item qty"
              outlined
              :max="editingItem.actuallQty"
              dense
              type="number"
              :error-messages="qtyCheckError"
            />

            <v-btn
              color="blue darken-1"
              text
              @click="showEditDialog = false"
            >
              Save
            </v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      gateways: ["card", "cheque", "cash", "other"],
      editingItem: {},
      showEditDialog: false,
      key: "",
      customer: {},
      isConfirmed: false,
      info: {},
      notFound: "",
      refundSuccess: false,
    };
  },
  computed: {
    ...mapGetters({
      products: "cart/items",
      items: "cart/totalQty",
      price: "cart/totalPrice",
    }),
    qtyCheckError() {
      if (this.$data.editingItem.qty > this.$data.editingItem.actuallQty) {
        this.resetQtyBack();
        return (
          "Quantity can not enter more then " +
          this.$data.editingItem.actuallQty +
          " sold "
        );
      }
      return "";
    },
    barcode() {
      return this.$data.info.barcode;
    },
    withShipping() {
      return this.price + Number(this.$data.info.shippingAmount);
    },
    taxAmount() {
      return this.withShipping * (this.$data.info.taxRate / 100);
    },
    totalWithTax() {
      return this.withShipping + this.taxAmount;
    },
    discountAmount() {
      return this.totalWithTax * (this.$data.info.discountRate / 100);
    },
    totalAfterDiscount() {
      return this.totalWithTax - this.discountAmount;
    },
  },

  mounted() {
    if (this.$route.params.trax) {
      this.$data.key = this.$route.params.trax;
      this.confirmSale();
    }
  },
  methods: {
    ...mapActions({
      removeItem: "cart/remove",
      clearCart: "cart/clear",
      feedback: "snackbar/show",
      saleForPrint: "misc/saleForPrint",
      loadCart: "cart/init",
    }),
    resetQtyBack() {
      setTimeout(() => {
        this.$data.editingItem.qty = this.$data.editingItem.actuallQty;
      }, 1000);
    },
    editItem(item) {
      this.$data.editingItem = item;
      this.$data.editingItem.actuallQty = item.qty;
      this.$data.showEditDialog = true;
    },
    prepare() {
      const order = this.$data.info;
      order.salling = null;
      order.purchasing = null;
      order.refunding = true;
      order.parent_id = order.id;
      order.discountAmount = this.discountAmount;
      order.taxAmount = this.taxAmount;
      order.totalItems = this.items;
      order.totalAmount = this.totalAfterDiscount;
      return order;
    },
    submitRefund() {
      window.axios.post("/sale-return", this.prepare()).then((response) => {
        this.$data.isConfirmed = false;
        this.feedback(response.data.message);
        this.clearCart();
        this.$router.push({
          name: "PrintRefund",
          params: { id: response.data.id },
        });
      });
    },
    confirmSale() {
      window.axios
        .post("/confirm-sale", { trx: this.$data.key })
        .then((response) => {
          const data = response.data;
          if (data.message) {
            this.$data.notFound = data.message;
          } else {
            this.$data.info = data.info;
            this.loadCart(data.info.items);
            this.$data.customer = data.customer;
            this.$data.isConfirmed = true;
          }
        });
    },
  },
};
</script>
